/**
 * AdminSlotsService 实现
 *
 * 管理员中心 Slot 注册服务的核心实现，负责 slot 的注册、存储、排序和订阅通知。
 */
/** 默认排序权重 */
const DEFAULT_ORDER = 100;
/**
 * 管理员中心 Slot 注册服务
 *
 * 管理第三方业务 Mod 注册到管理员中心的 UI 扩展槽位。
 * 支持订阅模式，页面可在 slot 增删时自动重渲染。
 */
export class AdminSlotsService {
    constructor() {
        /** 已注册的 slots，key 为 slot id */
        this.slots = new Map();
        /** 按 mod 注册的 slot id 映射，用于批量卸载 */
        this.modRegistry = new Map();
        /** 订阅者列表 */
        this.listeners = new Set();
    }
    registerSlot(slot) {
        if (this.slots.has(slot.id)) {
            throw new Error(`[AdminSlots] Slot conflict: "${slot.id}" already registered by mod "${this.slots.get(slot.id).modName}"`);
        }
        const normalizedSlot = {
            ...slot,
            order: slot.order ?? DEFAULT_ORDER,
        };
        this.slots.set(slot.id, normalizedSlot);
        if (slot.modName) {
            if (!this.modRegistry.has(slot.modName)) {
                this.modRegistry.set(slot.modName, new Set());
            }
            this.modRegistry.get(slot.modName).add(slot.id);
        }
        this.notifyListeners();
    }
    registerSlots(slots) {
        for (const slot of slots) {
            this.registerSlot(slot);
        }
    }
    unregisterModSlots(modName) {
        const slotIds = this.modRegistry.get(modName);
        if (!slotIds)
            return;
        for (const id of slotIds) {
            this.slots.delete(id);
        }
        this.modRegistry.delete(modName);
        this.notifyListeners();
    }
    getSlots() {
        const allSlots = Array.from(this.slots.values());
        const visibleSlots = allSlots.filter(slot => slot.visible?.() ?? true);
        return visibleSlots.sort((a, b) => (a.order ?? DEFAULT_ORDER) - (b.order ?? DEFAULT_ORDER));
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }
    notifyListeners() {
        this.listeners.forEach(listener => listener());
    }
}
//# sourceMappingURL=admin-slots-service.js.map